import { useFormContext, Controller } from "react-hook-form";
import { TextField, MenuItem, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { MetersChooserModal } from "components/MetersChooserModal";
import { Button } from "components/Button";

import { TInstallForm } from "../../../../hooks/useInstallForm";
import { MeterInfoMobile } from "components/mobileView/MeterInfoMobile";
import { SubscriberInfoMobile } from "components/mobileView/SubscriberInfoMobile";
import { SubscribersChooserModal } from "components/SubscribersChooserModal";
import { useTranslation } from "react-i18next";

const Step1 = () => {
  const { t } = useTranslation();
  const { control, watch } = useFormContext<TInstallForm>();

  const [isSubscriberChooserModalOpen, setIsSubscriberChooserModalOpen] =
    useState(false);
  const [isMetersChooserModalOpen, setIsMetersChooserModalOpen] =
    useState(false);

  return (
    <div className="flex flex-col">
      <Typography className={"font-bold text-md mb-4"}>
        {t("selectSubscriberAndMeter")}
      </Typography>
      <Controller
        name="subscriber"
        control={control}
        render={({ field }) => (
          <>
            <Button
              size={"large"}
              variant={"outlined"}
              onClick={() => setIsSubscriberChooserModalOpen(true)}
              className={"mb-2"}
            >
              {field.value
                ? t("changeSelectedSubscriber")
                : t("chooseSubscriber")}
            </Button>
            {field.value?.id && <SubscriberInfoMobile data={field.value} />}
            {isSubscriberChooserModalOpen && (
              <SubscribersChooserModal
                onClose={() => setIsSubscriberChooserModalOpen(false)}
                onSelectMeter={(meter) => {
                  field.onChange(meter);
                  setIsSubscriberChooserModalOpen(false);
                }}
                isOpen={isSubscriberChooserModalOpen}
              />
            )}
          </>
        )}
      />
      <Controller
        name="waterMeter"
        control={control}
        render={({ field }) => (
          <>
            <Button
              size={"large"}
              variant={"outlined"}
              onClick={() => setIsMetersChooserModalOpen(true)}
              className={"mt-8 mb-2"}
            >
              {field.value
                ? t("changeSelectedWaterMeter")
                : t("chooseWaterMeter")}
            </Button>
            {field.value?.id && <MeterInfoMobile data={field.value} />}
            {isMetersChooserModalOpen && (
              <MetersChooserModal
                onClose={() => setIsMetersChooserModalOpen(false)}
                onSelectMeter={(meter) => {
                  field.onChange(meter);
                  setIsMetersChooserModalOpen(false);
                }}
                isOpen={isMetersChooserModalOpen}
              />
            )}
          </>
        )}
      />
    </div>
  );
};

export default Step1;
